import { CommunityDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommunityService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCommunity(): Observable<CommunityDto[]> {
    return this.http.get<CommunityDto[]>(this.url + 'community');
  }

  createCommunity(data: CommunityDto[]): Observable<CommunityDto[]> {
    return this.http.post<CommunityDto[]>(this.url + 'community', data);
  }
  getSingleCommunity(id: string): Observable<any> {
    return this.http.get(this.url + 'community/' + id);
  }

  updateCommunity(data: CommunityDto[]): Observable<CommunityDto[]> {
    return this.http.post<CommunityDto[]>(this.url + 'community/update', data);
  }

  deleteCommunity(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('community', ids.join(', '));
    return this.http.delete(this.url + 'community', httpOptions);
  }
}
